import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { isLargeNarrowDown } from '@eb/eds-utils';
import { Button } from '@eb/eds-button';
import gettext from '@eb/gettext';

const LoadMapPanel = (props) =>
    props.mounted ? (
        <div
            className="eds-show-up-ln"
            style={{ position: 'fixed', top: '50%', right: '10%' }}
        >
            <Button data-testid="load-map-panel-btn" onClick={props.onClick}>
                {gettext('Load map')}
            </Button>
        </div>
    ) : null;

const lazyLoadMapPanel = () =>
    loadable(() => import('./ConnectedMapPanel'), { fallback: <div /> });

const LazyMapPanelContainer = () => {
    //Storing mounted status in state because we don't want to
    // render the "load" fallback experience on the server for desktop
    const [{ component: LazyComponent, mounted }, setLazyComponent] = useState({
        component: null,
        mounted: false,
    });

    useEffect(() => {
        if (!isLargeNarrowDown()) {
            setLazyComponent({ component: lazyLoadMapPanel(), mounted: true });
        } else {
            setLazyComponent({ component: null, mounted: true });
        }
    }, []);

    if (LazyComponent) {
        return <LazyComponent />;
    } else {
        return (
            <LoadMapPanel
                onClick={() =>
                    setLazyComponent({
                        component: lazyLoadMapPanel(),
                        mounted: true,
                    })
                }
                mounted={mounted}
            />
        );
    }
};

export default LazyMapPanelContainer;
